import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonSharedModule } from '@common/shared/common-shared.module';
import { CDK_MODULES, MATERIAL_MODULES, MATERIAL_PROVIDERS } from './material-modules';

import { ScrollingModule } from '@angular/cdk/scrolling';

import { CurrencyPipe, DatePipe } from '@angular/common';
import { DateAdapter } from '@angular/material/core';
import { BitfFormItemContainerComponent } from '@bitf/core/components/ui/form-item/bitf-form-item-container/bitf-form-item-container.component';
import { BitfMatLanguageSelectorComponent } from '@bitf/core/components/ui/language-selector/material/bitf-mat-language-selector.component';
import { BitfLoaderComponent } from '@bitf/core/components/ui/loader/bitf-loader.component';
import { BitfMatLoaderComponent } from '@bitf/core/components/ui/loader/material/bitf-mat-loader/bitf-mat-loader.component';
import { BitfMatPaginatorComponent } from '@bitf/core/components/ui/paginator/material/bitf-mat-paginator.component';
import { BitfMatSearchComponent } from '@bitf/core/components/ui/search/material/bitf-mat-search.component';
import { DateAdapterService } from '@common/core/services';
import { BitfDndFileComponent } from '@common/libs/bitforce/core/components/ui/dnd-file';
import { BitfMatFormItemComponent } from '@common/libs/bitforce/core/components/ui/form-item/material/mat-form-item/bitf-mat-form-item.component';
import { BitfMatFormOptionComponent } from '@common/libs/bitforce/core/components/ui/form-item/material/mat-form-option/bitf-mat-form-option.component';
import { BitfImageComponent } from '@common/libs/bitforce/core/components/ui/image/bitf-image/bitf-image.component';
import { BitfMatInfiniteScrollTriggerComponent } from '@common/libs/bitforce/core/components/ui/infinite-scroll/material/bitf-mat-infinite-scroll-trigger/bitf-mat-infinite-scroll-trigger.component';
import { BitfMatOkCancelDialogComponent } from '@common/libs/bitforce/core/components/ui/ok-cancel-dialog/material/bitf-mat-ok-cancel-dialog.component';
import { BitfMatSortComponent } from '@common/libs/bitforce/core/components/ui/sort/material/bitf-mat-sort.component';
import { BitfTouchEventDirective } from '@common/libs/bitforce/directives/bitf-touch-events/bitf-touch-event.directive';
import { BitfUiRoleManagerDirective } from '@common/libs/bitforce/directives/ui-role-manager/bitf-ui-role-manager.directive';
import { BitfBytesPipe } from '@common/libs/bitforce/pipes/bitf-bytes.pipe';
import { BitfCurrencyPipe } from '@common/libs/bitforce/pipes/bitf-currency.pipe';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { HeaderComponent } from '@web/core/components/header/header.component';
import { MenuComponent } from '@web/core/components/menu/menu.component';
import { PageHeaderComponent } from '@web/shared/components/page-header/page-header.component';
import { NgxEditorModule } from 'ngx-editor';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { AlertBannerComponent } from './components/alert-banner/alert-banner.component';
import { BookletStatusLegendComponent } from './components/booklet-status-legend/booklet-status-legend.component';
import { BookletBadgesLegendComponent } from './components/booklet-badges-legend/booklet-badges-legend.component';
import { BookletsDocumentsComponent } from './components/booklets-documents/booklets-documents.component';
import { BookletCostSummariesComponent } from './components/booklet-cost-summaries/booklet-cost-summaries.component';
import { CircularPhotoUploadComponent } from './components/circular-photo-upload/circular-photo-upload.component';
import { DocumentManagerComponent } from './components/document-manager/document-manager.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { ImagePreviewDialogComponent } from './components/image-preview-dialog/image-preview-dialog.component';
import { InputAutocompleteComponent } from './components/input-autocomplete/input-autocomplete.component';
import { InputDateComponent } from './components/input-date/input-date.component';
import { PolicyDialogComponent } from './components/policy-dialog/policy-dialog.component';
import { SkeletonTextComponent } from './components/skeleton-text/skeleton-text.component';
import { TextToSpeechButtonComponent } from './components/text-to-speech-button/text-to-speech-button.component';
import { UserInfoCardComponent } from './components/user-info-card/user-info-card.component';
import { DisplayUserPipe } from './pipes/display-user.pipe';

const SHARED_MODULES = [
  CommonSharedModule,
  RouterModule,
  MATERIAL_MODULES,
  CDK_MODULES,
  ScrollingModule,
  MonacoEditorModule.forRoot({ baseUrl: '/assets/monaco/min/vs' }),
  NgxEditorModule.forRoot({
    locals: {
      // menu
      bold: 'Bold',
      italic: 'Italic',
      code: 'Code',
      blockquote: 'Blockquote',
      underline: 'Underline',
      strike: 'Strike',
      bullet_list: 'Bullet List',
      ordered_list: 'Ordered List',
      heading: 'Heading',
      h1: 'Header 1',
      h2: 'Header 2',
      h3: 'Header 3',
      h4: 'Header 4',
      h5: 'Header 5',
      h6: 'Header 6',
      align_left: 'Left Align',
      align_center: 'Center Align',
      align_right: 'Right Align',
      align_justify: 'Justify',
      text_color: 'Text Color',
      background_color: 'Background Color',

      // popups, forms, others...
      url: 'URL',
      text: 'Text',
      openInNewTab: 'Open in new tab',
      insert: 'Insert',
      altText: 'Alt Text',
      title: 'Title',
      remove: 'Remove',
      enterValidUrl: 'Please enter a valid URL',
    },
  }),
  NgxChartsModule,
];
const SHARED_COMPONENTS = [
  BitfLoaderComponent,
  BitfMatPaginatorComponent,
  BitfUiRoleManagerDirective,
  BitfTouchEventDirective,
  BitfMatOkCancelDialogComponent,
  BitfMatLoaderComponent,
  BitfImageComponent,
  BitfMatInfiniteScrollTriggerComponent,
  BitfMatSearchComponent,
  BitfFormItemContainerComponent,
  BitfMatFormItemComponent,
  BitfDndFileComponent,
  HeaderComponent,
  MenuComponent,
  PageHeaderComponent,
  UserInfoCardComponent,
  BitfFormItemContainerComponent,
  DocumentManagerComponent,
  FileUploaderComponent,
  CircularPhotoUploadComponent,
  BitfDndFileComponent,
  BitfMatLanguageSelectorComponent,
  BookletsDocumentsComponent,
  BookletCostSummariesComponent,
  ImagePreviewDialogComponent,
  InputDateComponent,
  InputAutocompleteComponent,
  SkeletonTextComponent,
  AlertBannerComponent,
  TextToSpeechButtonComponent,
  BitfMatFormOptionComponent,
  BitfMatSortComponent,
  BookletStatusLegendComponent,
  BookletBadgesLegendComponent,
  PolicyDialogComponent,
];

const SHARED_DIRECTIVES = [];
const SHARED_PIPES = [BitfBytesPipe, DisplayUserPipe, BitfCurrencyPipe];
const PROVIDERS = [
  DatePipe,
  CurrencyPipe,
  BitfCurrencyPipe,
  { provide: DateAdapter, useClass: DateAdapterService },
];

@NgModule({
  imports: [...SHARED_MODULES],
  exports: [...SHARED_MODULES, ...SHARED_COMPONENTS, ...SHARED_DIRECTIVES, SHARED_PIPES],
  declarations: [...SHARED_COMPONENTS, ...SHARED_DIRECTIVES, SHARED_PIPES],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [...PROVIDERS, ...MATERIAL_PROVIDERS],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [],
    };
  }
}
